export default __webpack_public_path__ + "static/terms-dc3f0cd8c0128aed8948f950daa0bff3.pdf";